import {forwardRef, ReactNode} from 'react';
import {createPortal} from 'react-dom';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {StepStatus} from '../types';
import {getDocument, WebcamProps, WebcamRefTypes} from '@chekin/guestapp-ui-kit';
import {CustomIcon} from '@guestapp/old-ui-kit';
import {
  Title,
  Wrapper,
  StyledWebcam,
  BackIconButton,
  MobileLivenessInstructions,
  ChallengeProgressBarStyled,
} from './styled';

export type MobileCameraProps = WebcamProps & {
  disabled: boolean;
  status?: StepStatus;
  addon?: ReactNode;
};
const MobileWebcam = forwardRef<WebcamRefTypes, MobileCameraProps>(
  ({status, addon, ...props}, ref) => {
    const navigate = useNavigate();
    const rootElement = getDocument()?.body;
    const {t} = useTranslation();
    const onBack = () => navigate(-1);

    return createPortal(
      <Wrapper $status={status} className="mobile-camera">
        <BackIconButton onClick={onBack} className="mobile-camera__back-btn">
          <CustomIcon size={20} name="backBlueArrow" color="white" />
        </BackIconButton>
        <Title className="mobile-camera__title">{t('face_check')}</Title>
        <StyledWebcam ref={ref} {...props} />
        <ChallengeProgressBarStyled />
        <MobileLivenessInstructions />
        {addon}
      </Wrapper>,
      rootElement,
    );
  },
);

export {MobileWebcam};
